import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, Alert } from '@mui/material';
import axios from 'axios';

const AuthDebug = () => {
  const [email, setEmail] = useState('admin@example.com');
  const [password, setPassword] = useState('password');
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [testResponse, setTestResponse] = useState(null);

  const handleLogin = async () => {
    try {
      setError(null);
      const loginResponse = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, {
        email,
        password
      });
      
      setResponse(loginResponse.data);
      
      // Log the full response structure
      console.log('Login response:', loginResponse.data);
      
      // Store token based on the response structure
      if (loginResponse.data.data && loginResponse.data.data.token) {
        localStorage.setItem('token', loginResponse.data.data.token);
        setToken(loginResponse.data.data.token);
      } else if (loginResponse.data.token) {
        localStorage.setItem('token', loginResponse.data.token);
        setToken(loginResponse.data.token);
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data || 'Login failed');
    }
  };

  const testCategories = async () => {
    try {
      setError(null);
      const categoriesResponse = await axios.get(`${process.env.REACT_APP_API_URL}/categories`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      setTestResponse(categoriesResponse.data);
      console.log('Categories response:', categoriesResponse.data);
    } catch (err) {
      console.error('Categories error:', err);
      setError(err.response?.data || 'Failed to fetch categories');
    }
  };

  return (
    <Box sx={{ p: 4, maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>Authentication Debug</Typography>
        
        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            margin="normal"
          />
          <Button 
            variant="contained" 
            onClick={handleLogin}
            sx={{ mt: 2 }}
          >
            Login
          </Button>
        </Box>
        
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {JSON.stringify(error)}
          </Alert>
        )}
        
        {response && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6">Login Response:</Typography>
            <Paper sx={{ p: 2, bgcolor: '#f5f5f5', overflowX: 'auto' }}>
              <pre>{JSON.stringify(response, null, 2)}</pre>
            </Paper>
          </Box>
        )}
        
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6">Current Token:</Typography>
          <Paper sx={{ p: 2, bgcolor: '#f5f5f5', overflowX: 'auto', wordBreak: 'break-all' }}>
            {token || 'No token stored'}
          </Paper>
        </Box>
        
        <Button 
          variant="contained" 
          onClick={testCategories}
          sx={{ mt: 2 }}
          color="secondary"
        >
          Test Categories API
        </Button>
        
        {testResponse && (
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6">Categories Response:</Typography>
            <Paper sx={{ p: 2, bgcolor: '#f5f5f5', overflowX: 'auto' }}>
              <pre>{JSON.stringify(testResponse, null, 2)}</pre>
            </Paper>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default AuthDebug;
